import * as React from 'react';
import type { IStudyModelSectionBlockViewModel } from '../ViewModel/IStudyModelSectionBlockViewModel.csharp';
import type { LegacyStudyModelSectionBlockViewModel } from '../ViewModel/Legacy/LegacyStudyModelSectionBlockViewModel.csharp';
import type { StudyModelSectionBlockViewModel } from '../ViewModel/StudyModelSectionBlockViewModel.csharp';
import { StudyModelGrid } from '~/Features/StudyPage/Campus/Sections/StudyModelSection/Components/StudyModelGrid/StudyModelGrid';
import { StudyModelSectionAccordionItemWithFetch } from '~/Features/StudyPage/Campus/Sections/StudyModelSection/Components/StudyModelSectionAccordionItemWithFetch/StudyModelSectionAccordionItemWithFetch';
import { StudyModelSection } from '~/Features/StudyPage/Campus/Sections/StudyModelSection/StudyModelSection';
import {
    getAvailableYears,
    isLegacyView,
    isNewView,
    mapSettings,
    mapSubjects,
    mapSubjectsOptions,
    mapToOptions,
} from './StudyModelSectionBlockUtils';

export const StudyModelSectionBlock: React.FC<IStudyModelSectionBlockViewModel> = props => {
    const { id, teaser, studyProgramLink, settings, type } = props;

    const propsBase = {
        id,
        teaser,
        studyProgramLink,
        settings: mapSettings(settings),
    };

    if (isLegacyView(props)) {
        const { heading } = props;

        return (
            <StudyModelSection {...propsBase} heading={{ value: heading }}>
                <LegacyStudyModel {...props} />
            </StudyModelSection>
        );
    }

    if (isNewView(props)) {
        const { heading } = props;

        return (
            <StudyModelSection {...propsBase} heading={heading}>
                <StudyModel {...props} />
            </StudyModelSection>
        );
    }

    throw new Error(`Unsupported study model section: ${type}`);
};

const LegacyStudyModel: React.FC<LegacyStudyModelSectionBlockViewModel> = props => {
    const { studyModelAttributes, translations } = props;
    const { displayName, subjectToChanges, prerequisitesDisplayName, getStudyModelUrl } = studyModelAttributes;

    return (
        <StudyModelSectionAccordionItemWithFetch
            heading={displayName}
            contentAdditionalInfo={subjectToChanges}
            prerequisitesHeading={prerequisitesDisplayName}
            fetchUrl={getStudyModelUrl}
            translations={translations}
        />
    );
};

const StudyModel: React.FC<StudyModelSectionBlockViewModel> = props => {
    const { translations, subjects, getSubjectInfoUrl, overlayContentMessages } = props;
    const { genericErrorMessage, goToSubject, loading } = translations;

    return (
        <StudyModelGrid
            subjects={mapSubjects(subjects)}
            availableYears={getAvailableYears(subjects, translations)}
            specializationOptions={mapToOptions(subjects.map(subject => subject.specialization))}
            studyOptions={mapSubjectsOptions(subjects.map(subject => subject.studyOption))}
            getSubjectInfoUrl={getSubjectInfoUrl}
            overlayContentMessages={overlayContentMessages}
            translations={{
                ...translations,
                errorMessage: genericErrorMessage,
                buttonLabel: goToSubject,
                loadingMessage: loading,
            }}
        />
    );
};
